@if (column?.detailsOnly) {
<div class="d-flex align-items-center gap-1">
  <svg-icon src="assets/icons/visible.svg" class="action-icon"
            (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
</div>
} @else {
@if(expired) {

          @switch (this.data.statusOfCandidatOnMission) {
            @case (candidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
                              <svg-icon src="assets/icons/notif.svg" [tooltip]="'Envoyer un rappel à l\'établissement pour valider la mission'"
                                        (click)="sendReminder()" class="action-icon cursor-pointer"></svg-icon>
              </div>
            }
            @case (candidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
                            <svg-icon src="assets/icons/check.svg" [tooltip]="'Valider le paiement'" class="action-icon cursor-pointer"></svg-icon>
              </div>
            }
            @case (candidatStatusOnMission.PAYMENT_DONE) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
                            <svg-icon src="assets/icons/visible.svg" [tooltip]="'Voir les détails du paiement'" class="action-icon cursor-pointer"></svg-icon>
              </div>
            }
            @case (candidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
                            <svg-icon src="assets/icons/visible.svg" (click)="getMotifRefus()" [tooltip]="'Voir les raisons du refus de validation'" class="action-icon cursor-pointer"></svg-icon>
              </div>
            }
            @case (candidatStatusOnMission.CANCELED_BY_CANDIDATE) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
              </div>
            }
            @case (candidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
              </div>
            }
            @case (candidatStatusOnMission.ARCHIVED) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
              </div>
            }
            @case (candidatStatusOnMission.ACCEPTED) {
              <div class="d-flex align-items-center gap-1">
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                      (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
              </div>
            }
            @default {
              <div class="d-flex align-items-center gap-1">
                              <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                        (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
              </div>
            }
          }




} @else {
    <div class="">
      @switch (data.statusOfCandidatOnMission) {
        @case (candidatStatusOnMission.ACCEPTED) {
          @if (expired && data.missionStatus == candidatStatusOnMission.INVALIDATED) {
            <div class="d-flex align-items-center gap-1 flex-wrap">
              </div>
          } @else if (expired && data.missionStatus == candidatStatusOnMission.VALIDATED) {

          } @else {
            <div class="d-flex align-items-center gap-1 flex-wrap">
                            <app-button text="Contrat" color="accent" innerClass="cloud" [loading]="loadingContract"
                                        [tooltip]="'Générer le contrat'"
                                        (handleClick)="generateContract()"></app-button>
                            <svg-icon src="assets/icons/notif.svg" [tooltip]="'Envoyer un rappel pour signer le contrat'"
                                      (click)="sendReminder()" class="action-icon cursor-pointer"></svg-icon>
                            @if (canCancelCandidacy()) {<svg-icon src="assets/icons/close.svg" [tooltip]="'Annuler la candidature'"
                                      (click)="cancelCandidacy()" class="cursor-pointer"
                            ></svg-icon>}
                            <svg-icon src="assets/icons/visible.svg" class="action-icon"
                            (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
            </div>
          }
        }
        @case (candidatStatusOnMission.PAYMENT_DONE) {
          <div class="d-flex align-items-center gap-1">
          </div>
        }
        @case (candidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH) {
          <div class="d-flex align-items-center gap-1">
                        <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                  (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
                        @if (canCancelCandidacy()) {<svg-icon src="assets/icons/close.svg" [tooltip]="'Annuler la candidature'"
                                  (click)="cancelCandidacy()" class="cursor-pointer"
                        ></svg-icon>}
          </div>
        }
        @case (candidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION) {
          <div class="d-flex align-items-center gap-1">
                        <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                  (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
                        @if (canCancelCandidacy()) {<svg-icon src="assets/icons/close.svg" [tooltip]="'Annuler la candidature'"
                                  (click)="cancelCandidacy()" class="cursor-pointer"
                        ></svg-icon>}
          </div>
        }
        @case (candidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY) {
          <div class="d-flex align-items-center gap-1">
                        <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                  (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
          </div>
        }
        @case (candidatStatusOnMission.REJECTED) {
          <div class="d-flex align-items-center gap-1">
                        <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                  (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
          </div>
        }
        @case (candidatStatusOnMission.ARCHIVED || candidatStatusOnMission.CANCELED_BY_CANDIDATE || candidatStatusOnMission.CANCELLATION_ACCEPTED_AFTER_SIGNING) {
          <div class="d-flex align-items-center gap-1">
                        <svg-icon src="assets/icons/visible.svg" class="action-icon"
                                  (click)="openMissionDetails()" [tooltip]="'Voir les détails de la mission'"></svg-icon>
          </div>
        }
        @default {
          <div></div>
        }
      }
    </div>

  }
}
